export enum ContractStatus {
  draft = 'draft',
  sent = 'sent',
  signed = 'signed',
  lost = 'lost'
}
